var container = document.body;
var width = window.innerWidth;
var height = 200;
var wave = document.getElementById('wave');
var wave2 = document.getElementById('wave2');

var waveWidth = window.innerWidth;  // Wave SVG width (usually container width)
var waveHeight = 100;                   // Position from the top of container
var waveDelta = 50;                     // Wave amplitude
var speed = 0.2;                        // Wave animation speed
var wavePoints = (window.innerWidth > 700) ? 5 : 3;                     // How many point will be used to compute our wave

var points = [];

function calculateWavePoints(factor) {
  var points = [];
  
  for (var i = 0; i <= wavePoints; i++) {
    var x = i/wavePoints * waveWidth;
    var sinSeed = (factor + (i + i % wavePoints)) * speed * 100;
    var sinHeight = Math.sin(sinSeed / 100) * waveDelta;
    var yPos = Math.sin(sinSeed / 100) * sinHeight  + waveHeight;
    points.push({x: x, y: yPos});
  }

  return points;
}

function buildPath(points) {
  var SVGString = 'M ' + points[0].x + ' ' + points[0].y;

  var cp0 = {
    x: (points[1].x - points[0].x) / 2,
    y: (points[1].y - points[0].y) + points[0].y + (points[1].y - points[0].y)
  };

  SVGString += ' C ' + cp0.x + ' ' + cp0.y + ' ' + cp0.x + ' ' + cp0.y + ' ' + points[1].x + ' ' + points[1].y;

  var prevCp = cp0;
  var inverted = -1;

  for (var i = 1; i < points.length-1; i++) {
    var cpLength = Math.sqrt(prevCp.x * prevCp.x + prevCp.y * prevCp.y);
    var cp1 = {
      x: (points[i].x - prevCp.x) + points[i].x,
      y: (points[i].y - prevCp.y) + points[i].y
    };

    SVGString += ' C ' + cp1.x + ' ' + cp1.y + ' ' + cp1.x + ' ' + cp1.y + ' ' + points[i+1].x + ' ' + points[i+1].y;
    prevCp = cp1;
    inverted = -inverted;
  };

  SVGString += ' L ' + width + ' ' + height;
  SVGString += ' L 0 ' + height + ' Z';
  return SVGString;
}

var lastUpdate;
var totalTime = 0;

const waves = () => {
  var now = window.Date.now();

  if (lastUpdate) {
    var elapsed = (now-lastUpdate) / 1000;
    lastUpdate = now;

    totalTime += elapsed;
    
    var factor = totalTime*Math.PI;
    wave.setAttribute('d', buildPath(calculateWavePoints(factor)));
    wave2.setAttribute('d', buildPath(calculateWavePoints(factor)));
  } else {
    lastUpdate = now;
  }
  window.requestAnimationFrame(waves);
};

window.addEventListener('resize', function(){
  width = window.innerWidth;
  waveWidth = window.innerWidth;
  wavePoints = (window.innerWidth > 700) ? 5 : 3;
});

waves();